import { twMerge } from 'tailwind-merge';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { Icon, IconProps, Typography } from '@scale/scaleui';
import { ReactNode } from 'react';

export type SearchResultsListItemProps = {
  className?: string;
  title: ReactNode | ReactNode[];
  icon: FontAwesomeIconProps['icon'];
  variant?: IconProps['variant'];
  description: ReactNode | ReactNode[];
  type?: string;
};

export function SearchResultsListItem({
  className,
  title,
  icon,
  variant,
  description,
  type,
}: SearchResultsListItemProps) {
  return (
    <div
      className={twMerge(
        'min-h-14 p-3 flex items-center text-ellipsis justify-between gap-2',
        className,
      )}
    >
      <div className="flex items-center gap-2">
        <Icon icon={icon} size="md" className="flex-shrink-0" variant={variant} />
        <div className="text-left">
          <Typography.Paragraph2 className={twMerge('text-neutral-900 font-normal')}>
            {title}
          </Typography.Paragraph2>
          <Typography.Paragraph3
            className={twMerge('text-neutral-500 font-medium text-ellipsis overflow-hidden')}
          >
            {description}
          </Typography.Paragraph3>
        </div>
      </div>
      <Typography.Subtitle3 className="flex text-neutral-400 font-thin h-16 items-center">
        {type}
      </Typography.Subtitle3>
    </div>
  );
}
